import { render, staticRenderFns } from "./UniversCell.vue?vue&type=template&id=06668074&scoped=true"
import script from "./UniversCell.vue?vue&type=script&lang=js"
export * from "./UniversCell.vue?vue&type=script&lang=js"
import style0 from "./UniversCell.vue?vue&type=style&index=0&id=06668074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06668074",
  null
  
)

export default component.exports